import {
    ComponentKind,
    TableColumn,
    isStringTypeKind,
    ComponentDescription,
    LegacyPropertyDescription,
    InputOutputTables,
    makeEmptyComponentDescription,
} from "../description";
import { SerializedComponent } from "../../components/SerializedApp";
import { assert } from "../../Support";
import { ComponentDescriptor, makeStringyColumnPropertyDescriptor, ComponentBuilder } from ".";
import { ComponentHandlerBase } from "./handler";
import { getColumnProperty, makeColumnProperty } from "./property-utils";
import { PropertySection } from "./property-sections";
import { getDocURL } from "../../docUrl";

const ComponentKindYouTube: ComponentKind = "youtube";

interface YouTubeComponentDescription extends ComponentDescription {
    readonly propertyName: LegacyPropertyDescription;
}

export class YouTubeComponentHandler extends ComponentHandlerBase<YouTubeComponentDescription> {
    constructor() {
        super(ComponentKindYouTube);
    }

    public entryForTableColumn(
        { b }: ComponentBuilder,
        desc: YouTubeComponentDescription,
        tables: InputOutputTables
    ): SerializedComponent {
        const propertyName = getColumnProperty(desc.propertyName);
        if (propertyName === undefined) return b.errorUI;

        return b.ui("YouTube", {
            videoID: b.builtinCall("ExtractYouTubeVideoID", [b.getProperty(propertyName, b.getContext, tables.input)]),
        });
    }

    public getDescriptor(): ComponentDescriptor<YouTubeComponentDescription> {
        return {
            name: "YouTube",
            description: "Play a youtube video",
            img: "componentVideo",
            group: "Basic",
            helpUrl: getDocURL("youtube"),
            isLegacy: true,
            properties: [
                makeStringyColumnPropertyDescriptor(
                    "propertyName",
                    "Video",
                    ["required", "editable"],
                    PropertySection.Data,
                    undefined,
                    ["video", "youtube"],
                    [],
                    "uri"
                ),
                ...this.getBasePropertyDescriptors(),
            ],
        };
    }

    public static defaultComponent(column: TableColumn): YouTubeComponentDescription {
        assert(isStringTypeKind(column.type.kind));
        return {
            ...makeEmptyComponentDescription(ComponentKindYouTube),
            propertyName: makeColumnProperty(column.name),
        };
    }
}
